// Some common used types/enums
// Some needs to be replaced when the swagger-autogenerated models are not string types anymore

export enum RequestedType {
  'STANDARD' = 'STANDARD',
  'PARTS_ONLY' = 'PARTS_ONLY',
  'REFERENCING' = 'REFERENCING'
}

export enum DossierType {
  'FULL' = 'FULL',
  'SIMPLIFIED' = 'SIMPLIFIED'
}

export enum DossierNames {
  'PRODUCTNAME' = 'PRODUCTNAME',
  'PRODUCTNUMBER' = 'PRODUCTNUMBER',
  'ORGANAME' = 'ORGANAME',
  'PRODUCTDESCRIPTION' = 'PRODUCTDESCRIPTION',
  'VP_PROJECT_NAME' = 'VP_PROJECT_NAME',
  'VP_NUMBER' = 'VP_NUMBER',
  'OTHER' = 'OTHER'
}

export enum ProductionInEuType {
  'EU_PRODUCED' = 'EU_PRODUCED',
  'EU_IMPORTED' = 'EU_IMPORTED',
  'EU_PRODUCED_AND_IMPORTED' = 'EU_PRODUCED_AND_IMPORTED',
  'NO_DATA' = 'NO_DATA'
}

export enum PrimaryArticleIdentifierType {
  'PRIMARY' = 'PRIMARY',
  'VP_NUMBER' = 'VP_NUMBER',
  'PI_NUMBER' = 'PI_NUMBER',
  'OTHER' = 'OTHER'
}

export enum SubmissionStatus {
  DOSSIER_REQUESTED = 'DOSSIER_REQUESTED',
  DOSSIER_FILE_IN_PREPARATION = 'DOSSIER_FILE_IN_PREPARATION',
  DOSSIER_FAILED_TO_CREATE = 'DOSSIER_FAILED_TO_CREATE',
  DOSSIER_FILE_CREATED = 'DOSSIER_FILE_CREATED',
  DOSSIER_SENT_TO_ECHA = 'DOSSIER_SENT_TO_ECHA',
  PENDING = 'PENDING',
  SUBMITTED = 'SUBMITTED',
  ALL_PARTS_COMPLETED = 'ALL_PARTS_COMPLETED',
  ONE_OR_MORE_FAILED = 'ONE_OR_MORE_FAILED',
  VALIDATION_SUCCEEDED = 'VALIDATION_SUCCEEDED',
  FAILED = 'FAILED',
  VALIDATION_FAILED = 'VALIDATION_FAILED',
  DOSSIER_TOO_LARGE = 'DOSSIER_TOO_LARGE'
}

export enum SubmissionEmptyStatus {
  SUBMISSION_EMPTY = 'SUBMISSION_EMPTY'
}
export type SubmissionStatusWithEmpty = SubmissionStatus | SubmissionEmptyStatus;

export type ProductTypeType = 'ARTICLE' | 'COMPONENT' | 'SEMICOMPONENT' | 'MIXTURE' | 'HOMOGENEOUS_MATERIAL' | 'MATERIAL' | 'SUBSTANCE';
export enum ProductTypeEnum {
  ARTICLE = 'ARTICLE',
  COMPONENT = 'COMPONENT',
  SEMICOMPONENT = 'SEMICOMPONENT',
  MIXTURE = 'MIXTURE',
  HOMOGENEOUS_MATERIAL = 'HOMOGENEOUS_MATERIAL',
  MATERIAL = 'MATERIAL',
  SUBSTANCE = 'SUBSTANCE'
}
